import * as React from "react";
import { useState } from "react";
import "react-notifications-component/dist/theme.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { CardLink, CardText, Input, Spinner } from "reactstrap";
import { store } from "react-notifications-component";
import { Dispatch } from "redux";
import { videoHotlineAction } from "../../actions/videoHotlineAction";
import { DABBackToList, LoadingSpinnerModal } from "../../components/dab";
import { showAlertWithBacktrack } from "../common/functions";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { testimonialAction } from "../../actions/testimonialAction";
import HlsPlayer from "../testimonial/hlsPlayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

interface IVideoHotlineProps {
	dispatch: Dispatch<any>;
	videoHotlineData: any;
	testimonialData: any;
	callback: any;
	id: number;
}

const VideoHotlineDetail: React.SFC<IVideoHotlineProps> = ({
	dispatch,
	videoHotlineData,
	testimonialData,
	callback,
	id,
}) => {
	const history = useHistory();

	const [showModal, setShowModal] = useState(false);
	const [isDetailLoaded, setDetailLoaded] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);
	const [isPreviewPage, setIsPreviewPage] = useState(false);
	const [isVideoLoading, setIsVideoLoading] = useState(true);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleBackClick = (event) => {
		window.location.href = "/videohotline";
	};

	React.useEffect(() => {
		if (id >= 0) {
			dispatch(videoHotlineAction.videoHotlineGetDetail(id));
			setShowModal(true);
		}
	}, []);

	React.useEffect(() => {
		if (testimonialData?.isUpdateStatus) {
			dispatch(videoHotlineAction.videoHotlineGetDetail(id));
			var alertMessage = testimonialData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				testimonialData.isUpdateStatus = false;
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [testimonialData?.isUpdateStatus]);

	if (videoHotlineData) {
		if (
			videoHotlineData.isError &&
			!isErrorOnPage &&
			!videoHotlineData.isSuccess
		) {
			if (showModal) {
				setShowModal(false);
			}
			if (videoHotlineData.status === "Unauthorized") {
				history.push("/401");
			} else {
				showAlertWithBacktrack(videoHotlineData.status, true, history);
			}
			videoHotlineData.isError = false;
			setIsErrorOnPage(true);
		}

		if (videoHotlineData.isSuccess && !videoHotlineData.isError) {
			if (
				!isDetailLoaded &&
				videoHotlineData.videoHotlineInput &&
				videoHotlineData.videoHotlineInput !== null
			) {
				// callback(videoHotlineData.videoHotlineInput.title);
				setDetailLoaded(true);
			}
		}
		if (showModal) {
			setShowModal(false);
		}
	}
	const videoEnhanceStatus = (status) => {
		switch (status) {
			case 0:
				return "Enhancement in Progress";
			case 1:
				return "Enhanced Video";
			case 2:
				return "Original Video";
			default:
				return "Original Video";
		}
	};
	const handleStatusChange = async (status: string) => {
		try {
			const data = {
				adminUserId: parseInt(getLoggedUserId()),
				messageId: id,
				isApproved:
					status === "approved" ? true : status === "rejected" ? false : "",
			};
			setShowModal(true);
			await dispatch(testimonialAction.updateTestimonialStatus(data));
		} catch (error) {
			console.error("Failed to update testimonial:", error);
		}
	};

	return (
		<div className="videohotline-detail">
			{showModal && (
				<LoadingSpinnerModal
					isShowModal={showModal}
					modalChange={handleLoadShowModal}
				/>
			)}
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={handleBackClick}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to List
					</CardLink>
				</div>
				{videoHotlineData?.videoHotlineInput && (
					<>
						<CardText className="d-flex justify-content-between align-items-center">
							<span>
								<strong>Video Hotline ID: </strong> #
								{videoHotlineData?.videoHotlineInput?.messageId}
							</span>
							{videoHotlineData?.videoHotlineInput?.categoryName && (
								<span>
									<strong>Category name: </strong>
									{videoHotlineData?.videoHotlineInput?.categoryName}
								</span>
							)}
							<span className="video-status">
								<strong>Video status: </strong>
								{videoHotlineData?.videoHotlineInput?.messageAttachments?.[0]
									?.videoEnhanceStatus === 0 ? (
									<span>-</span>
								) : (
									<Input
										type="select"
										bsSize="sm"
										value={
											videoHotlineData?.videoHotlineInput?.isApproved === true
												? "approved"
												: videoHotlineData?.videoHotlineInput?.isApproved ===
												  false
												? "rejected"
												: "pending"
										}
										onChange={(e) => handleStatusChange(e.target.value)}
										style={{
											fontWeight: "bold",
											fontSize: "13px",
										}}
									>
										{videoHotlineData?.videoHotlineInput?.isApproved ===
											null && <option value="pending">Pending</option>}
										<option value="approved">Approved</option>
										<option value="rejected">Rejected</option>
									</Input>
								)}
							</span>
							{videoHotlineData?.videoHotlineInput?.createdByUser
								?.firstName && (
								<span className="videohotline-name">
									<strong>Author by:</strong>{" "}
									{videoHotlineData?.videoHotlineInput?.createdByUser
										?.firstName +
										" " +
										videoHotlineData?.videoHotlineInput?.createdByUser
											?.lastName}
								</span>
							)}
							<span>
								<strong>Video Status: </strong>
								{videoEnhanceStatus(
									videoHotlineData?.videoHotlineInput?.messageAttachments?.[0]
										?.videoEnhanceStatus
								)}
							</span>
							<span>
								<strong>Created Date: </strong>
								{new Date(
									videoHotlineData?.videoHotlineInput?.createdAtUtc
								).toLocaleDateString()}
							</span>
						</CardText>
						{videoHotlineData?.videoHotlineInput?.messageAttachments?.[0]
							?.videoEnhanceStatus === 0 ? (
							<h5 className="enhance-msg">
								<strong className="d-flex justify-content-center">
									Video Enhancement is in progress, please check back later.
								</strong>
							</h5>
						) : (
							<>
								{videoHotlineData?.videoHotlineInput?.messageAttachments?.[0]
									?.resourceUrl && (
									<div
										className="mb-3"
										style={{
											maxWidth: "100%",
											maxHeight: "90vh",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											overflow: "hidden",
										}}
									>
										<HlsPlayer
											src={
												videoHotlineData?.videoHotlineInput
													?.messageAttachments?.[0]?.resourceUrl
											}
										/>
									</div>
								)}
							</>
						)}
					</>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { videoHotlineData, testimonialData } = state;
	return {
		videoHotlineData,
		testimonialData,
	};
};

export default connect(mapStateToProps)(VideoHotlineDetail);
